export default __webpack_public_path__ + "static/scara-734404e01a7d2c9783e3e2629058eea8.jpg";